import React, { useState } from "react";
import axios from "axios";
import authHeader from "../services/auth-header";
import MarkerClusterGroup from "react-leaflet-markercluster";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import MarkerDesign from "./MarkerDesign";
import "./MarkerDesign.css";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  Tooltip,
  WMSTileLayer,
} from "react-leaflet";
import { Icon } from "leaflet";
import Mapchart from "./Mapchart";
import "../App.css";
import moment from "moment";
import pm25 from "../image/PM-2.5.png";
import pm10 from "../image/PM-10.png";
import aqi from "../image/AQI-Legend.png";
import fileDownload from "js-file-download";
import download_white_icon from "../image/download-white-icon.png";
import "bootstrap/dist/css/bootstrap.css";
require('react-leaflet-markercluster/dist/styles.min.css');

var good = new Icon({
  iconUrl: "https://nbiot.urbansciences.in/image-marker/good.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

var Satisfactory = new Icon({
  iconUrl: "https://nbiot.urbansciences.in/image-marker/Satisfactory.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

var moderate = new Icon({
  iconUrl: "https://nbiot.urbansciences.in/image-marker/moderate.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

var poor = new Icon({
  iconUrl: "https://nbiot.urbansciences.in/image-marker/poor.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

var verypoor = new Icon({
  iconUrl: "https://nbiot.urbansciences.in/image-marker/very-poor.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

var severe = new Icon({
  iconUrl: "https://nbiot.urbansciences.in/image-marker/severe.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

var offline = new Icon({
  iconUrl: "https://dashboard.urbansciences.in/image-marker/offline.png",
  iconSize: [35, 35],
  iconAnchor: [17, 34],
});

function Maps(props) {
  if (props.invalidtoken == "Token is invalid !!") {
    localStorage.clear();
    window.location.reload();
  }
  /////////////////////// 7 day //////////////////////

  var sevendays = moment().subtract(7, "days").format().substr(0, 16);
  /////////////////////// 1 day //////////////////////

  var onedays = moment().subtract(1, "days").format().substr(0, 16);

  /////////////////////// 30 day //////////////////////

  var onemonths = moment().subtract(30, "days").format().substr(0, 16);

  /****************************STATE******************************/
  // const [activePark, setActivePark] = useState(null);
  // let [mapcoor, setMapcoor] = useState([]);
  var [time, setTime] = useState(["hh"]);
  var [startdate, setStartdate] = useState(sevendays);
  var [enddate, setEnddate] = useState(moment().format().substr(0, 16));
  var [parameter, setParameter] = useState("pm2.5");
  var [slicetime, setSlicetime] = useState("1");
  var [tiptoolpara, setTiptoolpara] = useState("pm_2.5_raw_mean");
  const [markercd, setMarkercd] = useState("cluster");

  // const [content, setContent] = useState("");

  //////////////////////////////STYLE///////////////////////////////////
  const inputStyle = {
    width: "125px",
  };
  const inputLable = {
    marginBottom: "0px",
    color: "#A4A4A4",
    fontFamily: "Roboto",
    fontSize: "15px",
    lineHeight: "18px",
    fontWeight: "normal",
  };

  //////////////////////////////DOWNLOAD DATA //////////////////////////////

  var handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
        headers: authHeader(),
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };

  ///////////////////////////////HANDLE FUNCTION/////////////////////////

  const handleTime = (event) => {
    setTime(event.target.value);
  };

  const handleStartDate = (event) => {
    setStartdate(event.target.value);
  };

  const handleEnddate = (event) => {
    setEnddate(event.target.value);
  };

  const handleParameter = (event) => {
    setParameter(event.target.value);
  };

  const handleSlicetime = (event) => {
    setSlicetime(event.target.value);
  };

  const handleOneday = () => {
    setStartdate(onedays);
  };

  const handleSevenday = () => {
    setStartdate(sevendays);
  };

  const handleOnemonth = () => {
    setStartdate(onemonths);
  };

  const handleAqi = () => {
    setTiptoolpara("aqi");
  };

  const handlePm25 = () => {
    setTiptoolpara("pm_2.5_raw_mean");
  };

  const handlePm10 = () => {
    setTiptoolpara("pm_10_raw_mean");
  };

  let mapdatapoint1;
  let mapdatapoint2;
  let mapdatapoint3;
  let mapdatapoint4;
  let mapdatapoint5;
  let mapdatapoint6;
  let mapdatapoint7;
  let legend;
  let cluster;

  /////////////////////////////URL MOUNT/////////////////////////////////////
  // const API_URL = "https://atmos.urbansciences.in/adpl/getMapImei";

  // useEffect(() => {
  //   UserService.getUserBoard()
  //     .then((response) => response.data)
  //     // .then(response => setContent(response))
  //     .then((response) => {
  //       setContent(response);
  //     });

  // axios({
  //   method: "get",
  //   url: API_URL,
  //   headers: authHeader(),
  // }).then((response) => {
  //   setMapcoor(response.data.features);
  // });
  // }, []);
  // console.log('props.mapcoor',props.mapcoor)

  if (tiptoolpara === "pm_2.5_raw_mean") {
    mapdatapoint1 = props.mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] < 31 &&
          e.properties["pm_2.5_raw_mean"] >= 0 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={good}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-good">
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker >
      ));
    mapdatapoint2 = props.mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] < 61 &&
          e.properties["pm_2.5_raw_mean"] >= 31 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={Satisfactory}
          opacity="0"
        >
          <Tooltip
            permanent={true}
            direction="top"
            className="marker-main tooltip-satisfactory"
          >
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint3 = props.mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] < 91 &&
          e.properties["pm_2.5_raw_mean"] >= 61 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={moderate}
          opacity="0"
        >
          <Tooltip
            permanent={true}
            direction="top"
            className="marker-main tooltip-moderate"
          >
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint4 = props.mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] < 121 &&
          e.properties["pm_2.5_raw_mean"] >= 91 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={poor}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-poor">
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint5 = props.mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] < 250 &&
          e.properties["pm_2.5_raw_mean"] >= 121 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={verypoor}
          opacity="0"
        >
          <Tooltip
            permanent={true}
            direction="top"
            className="tooltip-verypoor"
          >
            <strong>
              {park.properties[`${tiptoolpara}`] != null
                ? park.properties[`${tiptoolpara}`].toFixed(0)
                : ""}
            </strong>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint6 = props.mapcoor
      .filter(
        (e) =>
          e.properties["pm_2.5_raw_mean"] >= 250 && e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={severe}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-severe">
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint7 = props.mapcoor
      .filter((e) => e.properties.status == 0)
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={offline}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-offline">
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
  } else if (tiptoolpara === "pm_10_raw_mean") {
    mapdatapoint1 = props.mapcoor
      .filter(
        (e) =>
          e.properties["pm_10_raw_mean"] < 51 &&
          e.properties["pm_10_raw_mean"] > 0 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={good}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-good">
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint2 = props.mapcoor
      .filter(
        (e) =>
          e.properties["pm_10_raw_mean"] < 101 &&
          e.properties["pm_10_raw_mean"] >= 51 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={Satisfactory}
          opacity="0"
        >
          <Tooltip
            permanent={true}
            direction="top"
            className="marker-main tooltip-satisfactory"
          >
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint3 = props.mapcoor
      .filter(
        (e) =>
          e.properties["pm_10_raw_mean"] < 251 &&
          e.properties["pm_10_raw_mean"] >= 101 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={moderate}
          opacity="0"
        >
          <Tooltip
            permanent={true}
            direction="top"
            className="marker-main tooltip-moderate"
          >
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint4 = props.mapcoor
      .filter(
        (e) =>
          e.properties["pm_10_raw_mean"] < 351 &&
          e.properties["pm_10_raw_mean"] >= 251 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={poor}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-poor">

            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint5 = props.mapcoor
      .filter(
        (e) =>
          e.properties["pm_10_raw_mean"] < 430 &&
          e.properties["pm_10_raw_mean"] >= 351 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={verypoor}
          opacity="0"
        >
          <Tooltip
            permanent={true}
            direction="top"
            className="marker-main tooltip-verypoor"
          >
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint6 = props.mapcoor
      .filter(
        (e) => e.properties["pm_10_raw_mean"] >= 430 && e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={severe}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-severe">
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint7 = props.mapcoor
      .filter((e) => e.properties.status == 0)
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={offline}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-offline">
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
  } else {
    mapdatapoint1 = props.mapcoor
      .filter(
        (e) =>
          e.properties["aqi"] < 51 &&
          e.properties["aqi"] > 0 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={good}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-good">
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint2 = props.mapcoor
      .filter(
        (e) =>
          e.properties["aqi"] < 101 &&
          e.properties["aqi"] >= 51 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={Satisfactory}
          opacity="0"
        >
          <Tooltip
            permanent={true}
            direction="top"
            className="marker-main tooltip-satisfactory"
          >
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint3 = props.mapcoor
      .filter(
        (e) =>
          e.properties["aqi"] < 201 &&
          e.properties["aqi"] >= 101 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={moderate}
          opacity="0"
        >
          <Tooltip
            permanent={true}
            direction="top"
            className="marker-main tooltip-moderate"
          >
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint4 = props.mapcoor
      .filter(
        (e) =>
          e.properties["aqi"] < 301 &&
          e.properties["aqi"] >= 201 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={poor}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-poor">
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint5 = props.mapcoor
      .filter(
        (e) =>
          e.properties["aqi"] < 401 &&
          e.properties["aqi"] >= 301 &&
          e.properties.status == 1
      )
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={verypoor}
          opacity="0"
        >
          <Tooltip
            permanent={true}
            direction="top"
            className="marker-main tooltip-verypoor"
          >
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint6 = props.mapcoor
      .filter((e) => e.properties["aqi"] >= 401 && e.properties.status == 1)
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={severe}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-severe">
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
    mapdatapoint7 = props.mapcoor
      .filter((e) => e.properties.status == 0)
      .map((park) => (
        <Marker
          key={park.properties.imei}
          position={[
            park.geometry.coordinates[1],
            park.geometry.coordinates[0],
          ]}
          icon={offline}
          opacity="0"
        >
          <Tooltip permanent={true} direction="top" className="marker-main tooltip-offline">
            <span className="marker-reading">{park.properties[`${tiptoolpara}`].toFixed(0)}</span>
          </Tooltip>
          <Popup id="leaflet-popup">
            <div className="graph-container">
              <p className="graph-container-heading">Map Details</p>
              <div className="row graph-chart-container">
                <div className="graph-container-text col-3">
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">IMEI</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.imei}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Pollutant</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties["pm_2.5_raw_mean"] == null
                        ? []
                        : park.properties["pm_2.5_raw_mean"].toFixed(2)}
                      μg/m
                      <sup>3</sup>
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Location</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.state}
                    </h5>
                  </div>
                  <div className="right-text-map-chart">
                    <h5 className="chart-map-data-left">Last Updated</h5>
                    <h5 className="chart-map-data-right">
                      {park.properties.last_updated.slice(0, 10)}
                    </h5>
                  </div>
                  <label className="map-chart-download-button">
                    <button
                      type="button"
                      className="btn btn-success"
                      onClick={() => {
                        handleDownload(
                          `https://atmos.urbansciences.in/adpl/getMapData/imei/${park.properties.imei}/startdate/${startdate}/enddate/${enddate}/ts/${time}/avg/1/para/${parameter}/type/csv`,
                          "Map_data.csv"
                        );
                      }}
                    >
                      Download Data
                      <img
                        src={download_white_icon}
                        alt="download"
                        width="15px"
                        style={{ marginLeft: "10px" }}
                      />
                    </button>
                  </label>
                </div>
                <div className="col-8">
                  <Mapchart
                    imei={park.properties.imei}
                    time={time}
                    startdate={startdate}
                    enddate={enddate}
                    parameter={parameter}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </Marker>
      ));
  }
  // //////////////////////Legend Code ///////////////////////////

  if (tiptoolpara === "pm_2.5_raw_mean") {
    legend = <img src={pm25} alt="pm2.5" width="600" />;
  } else if (tiptoolpara === "pm_10_raw_mean") {
    legend = <img src={pm10} alt="pm10" width="600" />;
  } else if (tiptoolpara === "aqi") {
    legend = <img src={aqi} alt="aqi1" width="600" />;
  }

  if (markercd.checked == false) {
    cluster = (
      <div>
        {mapdatapoint1}
        {mapdatapoint2}
        {mapdatapoint3}
        {mapdatapoint4}
        {mapdatapoint5}
        {mapdatapoint6}
        {mapdatapoint7}
      </div>
    );
  } else {
    cluster = (
      <MarkerClusterGroup>
        {mapdatapoint1}
        {mapdatapoint2}
        {mapdatapoint3}
        {mapdatapoint4}
        {mapdatapoint5}
        {mapdatapoint6}
        {mapdatapoint7}
      </MarkerClusterGroup>
    );
  }

  // ////////////////////////////MAIN CODE/////////////////////////
  // const position = props.mapcoor.map(coord =>
  //   coord.geometry)

  return (
    <div>
      <MapContainer center={[20.5937, 78.9629]} zoom={4}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        />
        {/* <WMSTileLayer
          format="image/png"
          layers={["geonode:states_in_india"]}
          url="https://pmuy-iitkaq.urbansciences.in/geoserver/wms"
          transparent="true"
          opacity="0.5"
        /> */}
        {/* //////////////////////////// Different Marker ///////////////////////////////////// */}
        {cluster}

        {/* ////////////////////////////////    POPUP   ///////////////////////////////////////// */}
      </MapContainer>
      <div className="mapChartOption">
        <form className="map-form">
          <div className="hori-line"></div>
          <p className="sort-by">Sort By :</p>
          <div
            className="row map-filter"
            style={{ borderBottom: "2px solid #F3F3F3" }}
          >
            <div className="font-weight-bold mr-2 my-2">
              <button
                type="button"
                className="map-button"
                onClick={handleOneday}
              >
                <a
                  className="map-button-text"
                  style={{ textDecoration: "none" }}
                >
                  24 Hrs
                </a>
              </button>
            </div>

            <div className="font-weight-bold mr-2 my-2">
              <button
                type="button"
                className="map-button"
                onClick={handleSevenday}
              >
                <a
                  className="map-button-text"
                  style={{ textDecoration: "none" }}
                >
                  7 Days
                </a>
              </button>
            </div>

            <div className="font-weight-bold my-2">
              <button
                type="button"
                className="map-button"
                onClick={handleOnemonth}
              >
                <a
                  className="map-button-text"
                  style={{ textDecoration: "none" }}
                >
                  30 Days
                </a>
              </button>
            </div>
          </div>

          <p className="sort-by">Filter :</p>

          <div className="row map-filter">
            <div className=" font-weight-bold">
              <label>
                <p style={inputLable}>Start Date</p>
                <input
                  type="datetime-local"
                  className="custom-select-input"
                  style={inputStyle}
                  placeholder="YYYYMMDD"
                  name="startDate"
                  value={startdate}
                  onChange={handleStartDate}
                />
              </label>
            </div>

            <div className=" font-weight-bold">
              <label>
                <p style={inputLable}>End Date</p>
                <input
                  type="datetime-local"
                  className="custom-select-input"
                  style={inputStyle}
                  placeholder="YYYYMMDD"
                  name="endDate"
                  value={enddate}
                  onChange={handleEnddate}
                />
              </label>
            </div>
          </div>

          <div className="row map-filter">
            <div className="font-weight-bold">
              <label>
                <p style={inputLable}>Average Time</p>
                <select
                  className="custom-select-input"
                  style={inputStyle}
                  value={time}
                  onChange={handleTime}
                >
                  <option value="mm">Minute</option>
                  <option value="hh">Hour</option>
                  <option value="dd">Day</option>
                </select>
              </label>
            </div>

            <div className=" font-weight-bold">
              <label>
                <p style={inputLable}>Pollutant</p>
                <select
                  className="custom-select-input"
                  style={inputStyle}
                  value={parameter}
                  onChange={handleParameter}
                >
                  <option value="select">Select</option>
                  <option value="pm2.5">PM2.5</option>
                  <option value="pm10">PM10</option>
                  <option value="ozone">ozone</option>
                  <option value="no2">no2</option>
                  <option value="o3op1">o3op1</option>
                  <option value="o3op2">o3op2</option>
                </select>
              </label>
            </div>
          </div>
          <div className="row map-filter">
            <div className="font-weight-bold">
              <label>
                <p style={inputLable}>Slice Time</p>
                <input
                  type="number"
                  placeholder="Enter number from 1-60"
                  min="0"
                  max="60"
                  className="custom-select-input"
                  style={inputStyle}
                  value={slicetime}
                  onChange={handleSlicetime}
                />
              </label>
            </div>
            <div className="font-weight-bold">
              <label>
                <p style={inputLable}>Cluster</p>
                <BootstrapSwitchButton
                  checked={true}
                  onstyle="outline-success"
                  offstyle="outline-danger"
                  onlabel="ON"
                  // width={125}
                  // height={30}
                  offlabel="OFF"
                  onChange={(checked: boolean) => {
                    setMarkercd({ checked });
                  }}
                />
              </label>
            </div>
          </div>

          <div className="row map-filter">
            {localStorage.getItem("check_aqi") === "1" && (
              <div className="font-weight-bold mr-2 my-2">
                <button
                  type="button"
                  className="map-button"
                  onClick={handleAqi}
                >
                  <a
                    className="map-button-text"
                    style={{ textDecoration: "none" }}
                  >
                    AQI
                  </a>
                </button>
              </div>
            )}

            <div className="font-weight-bold mr-2 my-2">
              <button type="button" className="map-button" onClick={handlePm25}>
                <a
                  className="map-button-text"
                  style={{ textDecoration: "none" }}
                >
                  PM2.5
                </a>
              </button>
            </div>

            <div className="font-weight-bold my-2">
              <button type="button" className="map-button" onClick={handlePm10}>
                <a
                  className="map-button-text"
                  style={{ textDecoration: "none" }}
                >
                  PM10
                </a>
              </button>
            </div>
          </div>
        </form>
      </div>
      <div className="my-legend">{legend}</div>
      <div className="map-bottom">
        <p>
          Disclaimer : All efforts have been made to make the Map accurate. The
          boundaries shown for the states and country are from{" "}
          <a href="https://www.surveyofindia.gov.in/pages/display/235-political-map-of-india">
            Survey of India, Government of India
          </a>
          . The Map shown here should be used only for educational and research
          purposes.
        </p>
      </div>
      {/* {!props.done ? (
          <ReactLoading type={"spinningBubbles"} color={"black"} className="react-loading" />
        ) : (
          null
        )} */}
    </div>
  );
}
export default Maps;
